import { Component, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { IPtTestList } from "app/models/core/admin/masterTables";
import { AdminService } from "app/services/admin/admin.service";
import { SharedService } from "app/services/core/shared.service";


@Component({
  selector: 'app-proficiencyTests',
  templateUrl: './proficiencyTests.component.html'

})

export class ProficiencyTestsComponent implements OnInit {

  list: IPtTestList[] = [];
  ptCategory: IPtTestList;
  displayedColumns: string[] = ['tId', 'ptTest', 'specialty', 'subSpecialty', 'testCode', 'action'];

  dataSource = new MatTableDataSource<IPtTestList>(this.list);

  listFilter = '';
  editMode = 'list';

  ptCategoryFormGroup = new UntypedFormGroup({
    PT_TEST_ID: new UntypedFormControl(0),
    Specialty: new UntypedFormControl('', [Validators.required, Validators.maxLength(10)]),
    SubSpecialty: new UntypedFormControl('', [Validators.required, Validators.maxLength(10)]),
    TCode: new UntypedFormControl('', [Validators.maxLength(10)]),
    TId: new UntypedFormControl('', [Validators.required, Validators.maxLength(3)]),
    PtTest: new UntypedFormControl('', [Validators.required]),
    Code: new UntypedFormControl('', [Validators.required]),
    LicAbbrev: new UntypedFormControl('')
  });

  @ViewChild('TablePaginator') paginator !: MatPaginator;
  @ViewChild('TableSort') sort!: MatSort;

  constructor(public adminService: AdminService,
    public sharedService: SharedService) { };

  ngOnInit() {
    this.editMode = 'list';
    this.loadPtTestsList();
  }

  loadPtTestsList() {
    this.adminService.getPtList().subscribe(
      res => {
        this.list = res;
        this.dataSource.data = this.list;
        this.timeout();
      },
      error => console.log('error: ', error),
      () => {
        this.editMode = 'list';
      }
    );
  }

  timeout() {
    setTimeout(() => {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }, 100);
  }

  filterTable(evnt: Event) {
    this.listFilter = (evnt.target as HTMLInputElement).value;
    this.dataSource.filter = this.listFilter.trim().toLowerCase();
  }

  clearFilter() {
    this.listFilter = "";
    this.dataSource.filter = this.listFilter;
  }

  getPageSizeOptions(): number[] {
    if (this.dataSource.data.length > 20) {
      return [10, 20, this.dataSource.data.length];
    } else {
      return [10, 20];
    }
  }

  editPtTestCategory(pt: IPtTestList) {
    this.ptCategory = pt;
    this.ptCategoryFormGroup.patchValue({
      PT_TEST_ID: pt.pT_TEST_ID,
      Specialty: pt.specialty,
      SubSpecialty: pt.subSpecialty,
      TCode: pt.tCode,
      TId: pt.tId,
      PtTest: pt.ptTest,
      Code: pt.code,
      LicAbbrev: pt.licAbbrev
    });
    this.ptCategoryFormGroup.markAsPristine();
    this.editMode = 'edit';
  }

  print() {
    //TODO
  }

  addPtTestCategory() {
    this.clearForm();
    this.editMode = 'add';
  }

  clearForm() {
    this.ptCategoryFormGroup.patchValue({
      PT_TEST_ID: 0,
      Specialty: '',
      SubSpecialty: '',
      TCode: '',
      TId: '',
      PtTest: '',
      Code: '',
      LicAbbrev: ''
    }
    );
  }

  savePtTestCategory() {
    if (this.ptCategoryFormGroup.valid && this.ptCategoryFormGroup.dirty) {
      let form = this.ptCategoryFormGroup.getRawValue();

      // Checking for duplicate codes
      let duplicate = false
      if (this.editMode == 'add') {
        let newCode = form.TId;
        this.list.forEach(function (val) {
          if (val.tId == newCode) {
            alert('Duplicate PT ID. Please edit existing record.');
            duplicate = true;
          }
        });
      }

      if (!duplicate) {
        let evaluator: IPtTestList = {
          pT_TEST_ID: +form.PT_TEST_ID,
          specialty: form.Specialty,
          subSpecialty: form.SubSpecialty,
          tCode: form.TCode,
          tId: form.TId,
          ptTest: form.PtTest,
          code: form.Code,
          licAbbrev: form.SubSpecialty
        };
        this.adminService.savePtTestCategory(evaluator, 'Save').subscribe(
          () => {
            this.loadPtTestsList();
          },
          error => console.log('error: ', error),
          () => {
          }
        );
      }
    }
  }

  deletePtTestCategory() {
    if (this.ptCategoryFormGroup.dirty) {
      if (!confirm('DELETE PT Category? Continue?')) {
        return;
      }
    }
    this.adminService.savePtTestCategory(this.ptCategory, 'Delete').subscribe(
      () => {
        this.loadPtTestsList();
      },
      error => console.log('error: ', error),
      () => {
      }
    );
  }

  cancel() {
    if (this.ptCategoryFormGroup.dirty) {
      if (!confirm('Unsaved changes. Continue?')) {
        return;
      }
    }
    this.clearForm();
    this.editMode = 'list';
  }

}